import axios from "axios";

export default function getSmtpSetting() {
  return new Promise((resolve, reject) => {
    axios
      .get(`/account/api/v1/smtp-settings`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
